import { Alert, AlertDescription } from '@/components/ui/alert';
import { Lock } from 'lucide-react';
import { useFeatureAccessForPIN } from '@/hooks/use-feature-access-for-pin';

interface FeatureGateProps {
  feature: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function FeatureGate({ feature, children, fallback }: FeatureGateProps) {
  const { hasAccess, loading } = useFeatureAccessForPIN(feature);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasAccess) {
    if (fallback !== undefined) return <>{fallback}</>;
    return (
      <div className="container mx-auto py-8">
        <Alert className="border-warning bg-warning/10">
          <Lock className="h-5 w-5 text-warning" />
          <AlertDescription className="ml-2 text-base">
            This section isn't enabled for your account.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <>{children}</>;
}
